import goalMemberPrivacySettingsModelDefinition from '../goalMemberPrivacySettings'

const create_goal_member_privacy_setting =
  goalMemberPrivacySettingsModelDefinition.schema.create;

export default {
  create({ displayName, userPicture, isCreator }) {
    return {
      isOwner: true,
      isAdmin: true,
      hasLeft: false, // NEU 27.03.2019
      cachedLog: "",
      cachedName: displayName,
      cachedProfilePic: userPicture,
      // cachedCommitmentTime
      // cachedCommitmentWeekdays
      // user: teamUserId
      acceptOrDecline: isCreator ? 1 : 0, // 1 = accept, 2 = decline
      privacy_settings: {
        'TEAM': create_goal_member_privacy_setting()
      }
    };
  },
  fields: {
    isOwner: { validate_bolt_type: 'Boolean' },
    isAdmin: { validate_bolt_type: 'Boolean' },
    hasLeft: { validate_bolt_type: 'Boolean' },
    cachedLog: { validate_bolt_type: 'String' },
    cachedName: { validate_bolt_type: 'String' },
    cachedProfilePic: { validate_bolt_type: 'String' },
    acceptOrDecline: { validate_bolt_type: 'Number' },
    privacy_settings: { validate_bolt_type: 'GoalMemberPrivacySettings[]' },
  }
};
